
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Expenses() {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedPeriod, setSelectedPeriod] = useState('month');

  const expenses = [
    {
      id: 1,
      title: 'فاتورة الكهرباء',
      amount: 450,
      category: 'utilities',
      date: '2024-01-15',
      icon: 'ri-flashlight-line',
      color: 'bg-yellow-100 text-yellow-600'
    },
    {
      id: 2,
      title: 'تسوق البقالة',
      amount: 320,
      category: 'food',
      date: '2024-01-14',
      icon: 'ri-shopping-cart-line',
      color: 'bg-green-100 text-green-600'
    },
    {
      id: 3,
      title: 'وقود السيارة',
      amount: 180,
      category: 'transport',
      date: '2024-01-13',
      icon: 'ri-gas-station-line',
      color: 'bg-blue-100 text-blue-600'
    },
    {
      id: 4,
      title: 'اشتراك نتفليكس',
      amount: 56,
      category: 'entertainment',
      date: '2024-01-12',
      icon: 'ri-tv-line',
      color: 'bg-purple-100 text-purple-600'
    },
    {
      id: 5,
      title: 'فاتورة الهاتف',
      amount: 120,
      category: 'utilities',
      date: '2024-01-11',
      icon: 'ri-phone-line',
      color: 'bg-orange-100 text-orange-600'
    }
  ];

  const categories = [
    { id: 'all', name: 'الكل', icon: 'ri-apps-line' },
    { id: 'food', name: 'طعام', icon: 'ri-restaurant-line' },
    { id: 'transport', name: 'مواصلات', icon: 'ri-car-line' },
    { id: 'utilities', name: 'فواتير', icon: 'ri-bill-line' },
    { id: 'entertainment', name: 'ترفيه', icon: 'ri-gamepad-line' }
  ];

  const filteredExpenses = selectedCategory === 'all' 
    ? expenses 
    : expenses.filter(expense => expense.category === selectedCategory);

  const totalExpenses = filteredExpenses.reduce((sum, expense) => sum + expense.amount, 0);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="fixed top-0 w-full bg-white shadow-sm z-50">
        <div className="flex items-center justify-between px-6 py-4">
          <button 
            onClick={() => navigate('/dashboard')}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100"
          >
            <i className="ri-arrow-right-line text-xl text-gray-700"></i>
          </button>
          <h1 className="text-xl font-bold text-gray-800">المصروفات</h1>
          <button 
            onClick={() => navigate('/add-expense')}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-600"
          >
            <i className="ri-add-line text-xl text-white"></i>
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="pt-20 pb-24 px-6">
        {/* Summary Card */}
        <div className="bg-gradient-to-r from-red-500 to-pink-500 rounded-2xl p-6 text-white mb-6">
          <div className="flex items-center justify-between mb-4">
            <div>
              <p className="text-red-100 text-sm">إجمالي المصروفات</p>
              <p className="text-2xl font-bold">{totalExpenses.toLocaleString()} ريال</p>
            </div>
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-arrow-down-line text-2xl"></i>
            </div>
          </div>
          
          {/* Period Selector */}
          <div className="flex bg-white/20 rounded-full p-1">
            <button 
              onClick={() => setSelectedPeriod('week')}
              className={`flex-1 py-2 px-4 rounded-full text-sm font-medium transition-all ${
                selectedPeriod === 'week' ? 'bg-white text-red-500' : 'text-white'
              }`}
            >
              أسبوع
            </button>
            <button 
              onClick={() => setSelectedPeriod('month')}
              className={`flex-1 py-2 px-4 rounded-full text-sm font-medium transition-all ${
                selectedPeriod === 'month' ? 'bg-white text-red-500' : 'text-white'
              }`}
            >
              شهر
            </button>
            <button 
              onClick={() => setSelectedPeriod('year')}
              className={`flex-1 py-2 px-4 rounded-full text-sm font-medium transition-all ${
                selectedPeriod === 'year' ? 'bg-white text-red-500' : 'text-white'
              }`}
            >
              سنة
            </button>
          </div>
        </div>

        {/* Categories */}
        <div className="mb-6">
          <div className="flex space-x-3 space-x-reverse overflow-x-auto pb-2">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`flex-shrink-0 flex items-center space-x-2 space-x-reverse px-4 py-2 rounded-full transition-all ${
                  selectedCategory === category.id
                    ? 'bg-blue-600 text-white'
                    : 'bg-white text-gray-600 border border-gray-200'
                }`}
              >
                <i className={`${category.icon} text-sm`}></i>
                <span className="text-sm font-medium whitespace-nowrap">{category.name}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Expenses List */}
        <div className="space-y-3">
          {filteredExpenses.map((expense) => (
            <div key={expense.id} className="bg-white rounded-2xl p-4 shadow-sm">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3 space-x-reverse">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center ${expense.color}`}>
                    <i className={`${expense.icon} text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">{expense.title}</h3>
                    <p className="text-gray-500 text-sm">{expense.date}</p>
                  </div>
                </div>
                <div className="text-left">
                  <p className="text-lg font-bold text-red-600">-{expense.amount} ريال</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredExpenses.length === 0 && (
          <div className="text-center py-12">
            <div className="w-20 h-20 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
              <i className="ri-file-list-line text-2xl text-gray-400"></i>
            </div>
            <p className="text-gray-500">لا توجد مصروفات في هذه الفئة</p>
          </div>
        )}
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 w-full bg-white border-t border-gray-200">
        <div className="grid grid-cols-4 py-2">
          <button 
            onClick={() => navigate('/dashboard')}
            className="flex flex-col items-center justify-center py-2"
          >
            <div className="w-6 h-6 flex items-center justify-center mb-1">
              <i className="ri-home-line text-gray-400 text-lg"></i>
            </div>
            <span className="text-xs text-gray-400">الرئيسية</span>
          </button>
          <button 
            onClick={() => navigate('/expenses')}
            className="flex flex-col items-center justify-center py-2"
          >
            <div className="w-6 h-6 flex items-center justify-center mb-1">
              <i className="ri-arrow-down-line text-red-600 text-lg"></i>
            </div>
            <span className="text-xs text-red-600 font-medium">المصروفات</span>
          </button>
          <button 
            onClick={() => navigate('/reports')}
            className="flex flex-col items-center justify-center py-2"
          >
            <div className="w-6 h-6 flex items-center justify-center mb-1">
              <i className="ri-bar-chart-line text-gray-400 text-lg"></i>
            </div>
            <span className="text-xs text-gray-400">التقارير</span>
          </button>
          <button 
            onClick={() => navigate('/financial-alert')}
            className="flex flex-col items-center justify-center py-2"
          >
            <div className="w-6 h-6 flex items-center justify-center mb-1">
              <i className="ri-notification-line text-gray-400 text-lg"></i>
            </div>
            <span className="text-xs text-gray-400">التنبيهات</span>
          </button>
        </div>
      </div>
    </div>
  );
}
